import React from 'react'
import View from 'src/components/atoms/View'
import MessagesList from '../MessagesList'
import MessageLoader from '../MessageLoader'
import MessageInput from '../MessageInput'
import { useSelector } from 'react-redux'
import { RootReducer } from 'src/redux/rootReducer'
import ConversationWrapper from './ConversationWrapper'
import { useTranslation } from 'react-i18next'
import Text from 'src/components/atoms/Text'
import MessagesSvg from 'src/components/other/svg/MessagesSvg'
import Space from 'src/components/atoms/Space'
interface Props {
  offerHashId: string
}

const Conversation = ({ offerHashId }: Props): JSX.Element => {
  const { messages, isAdminTyping } = useSelector((state: RootReducer) => state.conversationReducer)

  const { t } = useTranslation()
  return (
    <ConversationWrapper offerHashId={offerHashId}>
      <View className="flex flex-col justify-between bg-groupBlue rounded-4 p-4 h-full">
        <View className="flex items-center gap-2">
          <MessagesSvg className="w-8 h-8 text-white" />
          <Text className="!text-white !text-xl !font-bold">{t('messages')}</Text>
        </View>
        <Space y={15} />
        <MessagesList messages={messages} variant="OfferMessage" />
        <MessageLoader isLoading={isAdminTyping} variant="OfferMessage" />
        <MessageInput offerHashId={offerHashId} variant="OfferMessage" />
      </View>
    </ConversationWrapper>
  )
}

export default Conversation
